import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  events: [],
  selectedCell: { court: '', hour: '' },
  error: '',
  editingEvent: null,
  // Cache calendar API responses by date key to avoid re-fetching on navigation
  calendarCache: {},
};

const calendarSlice = createSlice({
  name: 'calendar',
  initialState,
  reducers: {
    setSelectedCell: (state, action) => {
      state.selectedCell = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setEditingEvent: (state, action) => {
      state.editingEvent = action.payload;
    },
    addEvent: (state, action) => {
      state.events.push(action.payload);
    },
    updateEvent: (state, action) => {
      state.events = state.events.map((event) =>
        event.id === action.payload.id ? action.payload : event
      );
    },
    deleteEvent: (state, action) => {
      state.events = state.events.filter(
        (event) => event.id !== action.payload
      );
    },
    setEvents: (state, action) => {
      state.events = action.payload;
    },
    setCachedCalendarData: (state, action) => {
      const { date, data } = action.payload;
      state.calendarCache[date] = data;
    },
    invalidateCacheForDate: (state, action) => {
      delete state.calendarCache[action.payload];
    },
    clearCalendarCache: (state) => {
      state.calendarCache = {};
    },
  },
});

export const {
  setSelectedCell,
  setError,
  setEditingEvent,
  setEvents,
  addEvent,
  updateEvent,
  deleteEvent,
  setCachedCalendarData,
  invalidateCacheForDate,
  clearCalendarCache,
} = calendarSlice.actions;

export default calendarSlice.reducer;
